import Vue from "vue";
import OutdatedBrowser from "outdated-browser-rework";
import LazyLoad from "vanilla-lazyload";
import AnalyticsHelper from "@Scripts/Infrastructure/AnalyticsHelper";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        AppConfig.AddComponents();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.setImageLazyLoading();
        this.resetCssAnimations();
        this.setZombieBrowsers();
        this.setAnalytics();
        this.setShareButton();
        this.setModal();
        this.setSearch();
        this.setWrapMenu();

        let self = this;
        (<any>window).fbAsyncInit = function () {
            FB.init(<facebook.InitParams>{
                xfbml: true,
                version: "v5.0"
            });
            FB.Event.subscribe(<facebook.FacebookEventType>"customerchat.dialogShow", function () { self.onCustomerChatDialogShow() });
        }
    }

    private static resetCssAnimations() {
        // Styles animations reset
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static setImageLazyLoading() {
        var lazyLoadInstance = new LazyLoad();
    }

    private static setZombieBrowsers() {
        OutdatedBrowser({
            browserSupport: {
                "IE": false
            },
            bgColor: "#E18300",
            color: "#ffffff",
            isUnknownBrowserOK: true
        });
    }

    private static setAnalytics() {
        if ((<any>window).gascrolldepth) {
            (<any>window).gascrolldepth.init({
                userTiming: false,
                pixelDepth: false,
                nonInteraction: false
            });
        }

        let gaEventItems = document.querySelectorAll("[data-gaevent=\"true\"]");
        if (gaEventItems && gaEventItems.length != 0) {
            for (let i = 0; i < gaEventItems.length; i++) {
                gaEventItems[i].addEventListener("click", function () {
                    AnalyticsHelper.sendEvent(gaEventItems[i].getAttribute("data-gacategory"), gaEventItems[i].getAttribute("data-gaaction"), gaEventItems[i].getAttribute("data-galabel"));
                });
            }
        }

        let gaEventEditorItems = document.querySelectorAll(".editor a");
        if (gaEventEditorItems && gaEventEditorItems.length != 0) {
            for (let i = 0; i < gaEventEditorItems.length; i++) {
                gaEventEditorItems[i].addEventListener("click", function () {
                    AnalyticsHelper.sendEvent("Page", "Click", gaEventEditorItems[i].getAttribute("href"));
                });
            }
        }
    }

    private static setModal() {
        let privacyPolicy = document.getElementById("PrivacyPolicy");
        if (privacyPolicy) {
            (<any>window).lightGallery(privacyPolicy, {
                selector: "this",
                download: false,
                counter: false
            });
        }

        let cookieToastPrivacyLink = document.getElementById("CookieToastPrivacyLink");
        if (cookieToastPrivacyLink) {
            (<any>window).lightGallery(cookieToastPrivacyLink, {
                selector: "this",
                download: false,
                counter: false
            });
        }
    }

    private static setShareButton() {
        let openShare = document.getElementById("OpenShare"),
            shareBox = document.getElementById("ShareBox");

        if (openShare) {
            openShare.addEventListener("click", function () {
                shareBox.classList.toggle("show");
            });
        }
    }

    private static setSearch() {
        let openSearchButton = document.getElementById("OpenSearchButton"),
            closeSearchButton = document.getElementById("CloseSearchButton"),
            headerMainMenu = document.getElementById("MainMenu"),
            searchBox = document.getElementById("SearchBox"),
            wrapTap = document.getElementById("WrapTap");

        if (openSearchButton) {
            openSearchButton.addEventListener("click", function () {
                if (headerMainMenu) {
                    let headerMainMenuElements = headerMainMenu.querySelectorAll(".item");

                    if (headerMainMenuElements) {
                        for (let i = 0; i < headerMainMenuElements.length; i++) {
                            let element = headerMainMenuElements[i];

                            element.classList.add("hden");
                            element.setAttribute("data-search", "active");
                        }
                    }

                    if (searchBox) {
                        searchBox.classList.remove("hden");
                        searchBox.setAttribute("data-search", "active");
                    }

                    if (wrapTap) {
                        wrapTap.classList.add("show");
                    }

                    if (closeSearchButton) {
                        closeSearchButton.classList.remove("hden");
                    }

                    openSearchButton.classList.add("hden");
                }
            });
        }

        if (closeSearchButton) {
            closeSearchButton.addEventListener("click", function () {
                if (headerMainMenu) {
                    let headerMainMenuElements = headerMainMenu.querySelectorAll(".item");

                    if (headerMainMenuElements) {
                        for (let i = 0; i < headerMainMenuElements.length; i++) {
                            let element = headerMainMenuElements[i];

                            element.classList.remove("hden");
                            element.removeAttribute("data-search");
                        }
                    }

                    if (searchBox) {
                        searchBox.classList.add("hden");
                        searchBox.removeAttribute("data-search");
                    }

                    if (wrapTap) {
                        wrapTap.classList.remove("show")
                    }

                    if (openSearchButton) {
                        openSearchButton.classList.remove("hden");
                    }

                    closeSearchButton.classList.add("hden");
                }
            });
        }

        if (wrapTap) {
            wrapTap.addEventListener("click", function () {
                if (wrapTap.classList.contains("show")) {
                    if (headerMainMenu) {
                        let headerMainMenuElements = headerMainMenu.querySelectorAll(".item");

                        if (headerMainMenuElements) {
                            for (let i = 0; i < headerMainMenuElements.length; i++) {
                                let element = headerMainMenuElements[i];

                                element.classList.remove("hden");
                                element.removeAttribute("data-search");
                            }
                        }

                        if (searchBox) {
                            searchBox.classList.add("hden");
                            searchBox.removeAttribute("data-search");
                        }

                        if (closeSearchButton) {
                            closeSearchButton.classList.add("hden")
                        }

                        if (openSearchButton) {
                            openSearchButton.classList.remove("hden");
                        }

                        wrapTap.classList.remove("show");
                    }
                }
            });
        }
    }

    private static setWrapMenu() {
        let openButton = document.getElementById("OpenButtonWrapMenu"),
            closeButton = document.getElementById("CloseButtonWrapMenu");

        if (openButton) {
            openButton.addEventListener("click", function () {
                let mainMenu = document.getElementById("MainMenu"),
                    wrapTapMenu = document.getElementById("WrapTapMenu");

                if (mainMenu) {
                    mainMenu.setAttribute("data-active", "true");
                }

                if (wrapTapMenu) {
                    wrapTapMenu.classList.add("show");
                    wrapTapMenu.setAttribute("data-wrap", "true");
                }

                if (closeButton) {
                    closeButton.classList.remove("hden");
                }

                openButton.classList.add("hden");
            });
        }

        if (closeButton) {
            closeButton.addEventListener("click", function () {
                let mainMenu = document.getElementById("MainMenu"),
                    wrapTapMenu = document.getElementById("WrapTapMenu");

                if (mainMenu) {
                    mainMenu.removeAttribute("data-active");
                }

                if (wrapTapMenu) {
                    wrapTapMenu.classList.remove("show");
                    wrapTapMenu.removeAttribute("data-wrap");
                }

                if (openButton) {
                    openButton.classList.remove("hden");
                }

                closeButton.classList.add("hden");
            });
        }

    }

    private static onCustomerChatDialogShow() {
        AnalyticsHelper.sendEvent("Facebook", "Click", "OpenCustomerChat");
    }
}